<material-table [allTableColumns]="allTableColumns" [selectedColumns]='selectedColumns' [data]="tableData" [hidePaginator]="hidePaginator" (filesChanged)="filesChanged($event)" (DownloadSourceTemplate)="DownloadSourceTemplate($event)">
</material-table>
